// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"52a1181810e54679a133","325":"92c768e56182141f4c4e","636":"1643f5e53ef31ab2e8d0"}[chunkId] + ".js";
};